import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { RoutingService } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { Subscription } from "rxjs";
import { CustomAddToCartService } from "src/app/custom-add-to-cart/custom-add-to-cart.service";
import { BaseService } from "src/app/shared/services/base.service";


@Component({
  selector: 'app-influenza-cart',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './influenza-cart.component.html',
  styleUrls: ['./influenza-cart.component.scss']
})
export class InfluenzaCartComponent implements OnInit {
  cartId: any;
  userSubscription: Subscription;
  userData: any;
  allCartItemsSub: Subscription;

  constructor(public activeModal: NgbActiveModal, private readonly addToCart: CustomAddToCartService,
    private readonly user: UserAccountFacade, public baseService: BaseService,
    private readonly router: RoutingService) { }

  ngOnInit(): void {
    this.userSubscription = this.user.get().subscribe((res) => {
      if (res !== undefined) {
        this.userData = res;
        // this.addToCart.getAllCarts(this.userData?.uid);
        this.allCartItemsSub = this.addToCart.allCartItems$.subscribe((res) => {
          if (res) {
            let cartItems = res?.carts;
            cartItems = cartItems[cartItems?.length - 1];
            this.cartId = cartItems?.code;
            this.allCartItemsSub?.unsubscribe();
          }
        })
      }
    })
  }
  influenzaPage() {
    this.addToCart.clearCart(this.cartId,'flupage');
    this.activeModal.dismiss();
    // this.baseService
    //   .delete(config.USER_ACCOUNT + this.userData?.uid + '/carts/' + this.cartId)
    //   .subscribe((res) => {
    //     if (res) {
    //       this.activeModal.dismiss();

    //     }
    //   });
  }
  
  redirectToDashboard(){
    this.activeModal.dismiss();
   // this.router.goByUrl('my-account/account-overview');
   history.back();
  }
  
  ngOnDestroy() {
    this.allCartItemsSub?.unsubscribe();
  }

}
